var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailDarkBlue = function SvgMailDarkBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00586C",
    d: "M20.75 2H4.25A2.25 2.25 0 0 0 2 4.25v16.5A2.25 2.25 0 0 0 4.25 23h16.5A2.25 2.25 0 0 0 23 20.75V4.25A2.25 2.25 0 0 0 20.75 2m-10.4 10.786C6.097 9.701 6.141 9.693 5 8.805v-1.18C5 7.004 5.504 6.5 6.125 6.5h12.75c.621 0 1.125.504 1.125 1.125v1.18c-1.142.889-1.099.896-5.35 3.981-.491.359-1.47 1.225-2.15 1.214-.68.01-1.658-.854-2.15-1.214M20 10.708v6.667c0 .621-.504 1.125-1.125 1.125H6.125A1.125 1.125 0 0 1 5 17.375v-6.667c.654.506 1.562 1.183 4.467 3.291.664.485 1.78 1.507 3.033 1.501 1.26.006 2.392-1.033 3.034-1.501 2.904-2.108 3.812-2.785 4.466-3.29"
  })));
};
export default SvgMailDarkBlue;